import { Link } from 'react-router-dom';

import AgentRow from './agent-row';
import EmptyState from '../../../common/components/state-message/empty-state';
import LoadingState from '../../../common/components/state-message/loading-state';
import ChevronRightIcon from '../../../common/icons/chevron-right';
import { ROUTES } from '../../../core/constants/routes';
import { nameOf } from '../../../global/contexts/catalogs/catalogs';
import { useTeamMembers, useTeamProjects } from '../contexts/teams';
import { useSimulation } from '../contexts/simulation';
import { agentsOfTeam } from '../utils/agents';

import '../styles/team-block.css';

export default function TeamBlock({ team, seats, projects, statusFilter }) {
    const membersQuery = useTeamMembers(team.id);
    const projectsQuery = useTeamProjects(team.id);
    const { overrides } = useSimulation();

    const agents = agentsOfTeam(seats, membersQuery.data?.items ?? [], overrides);
    const visible = statusFilter ? agents.filter((agent) => agent.status === statusFilter) : agents;
    const projectIds = (projectsQuery.data?.items ?? []).map((link) => link.projectId);

    return (
        <article className="team-block" aria-labelledby={`team-${team.id}`}>
            <header className="team-block__header">
                <Link to={ROUTES.TEAM(team.id)} className="team-block__title-link">
                    <h2 id={`team-${team.id}`} className="team-block__title">{team.name}</h2>
                    <ChevronRightIcon size={20} />
                </Link>
                <p className="team-block__description">{team.description}</p>
                <ul className="team-block__projects" aria-label={`Proyectos de ${team.name}`}>
                    {projectIds.map((projectId) => (
                        <li key={projectId}>
                            <Link to={ROUTES.PROJECT(projectId)} className="team-block__project">{nameOf(projects, projectId, 'Proyecto')}</Link>
                        </li>
                    ))}
                </ul>
            </header>
            <h3 className="team-block__subheading">
                Agentes <span className="team-block__count">{membersQuery.isPending ? '' : `${visible.length}/${agents.length}`}</span>
            </h3>
            {membersQuery.isPending && <LoadingState label="Cargando agentes del equipo" rows={2} />}
            {membersQuery.isSuccess && visible.length === 0 && (
                <EmptyState title={statusFilter ? 'Ningún agente en este estado' : 'Este equipo no tiene agentes'} />
            )}
            {visible.length > 0 && (
                <ul className="team-block__agents">
                    {visible.map((agent) => <AgentRow key={agent.seat.id} agent={agent} />)}
                </ul>
            )}
        </article>
    );
}
